//--------------Dummy Data for GroupsTable--------------//

const Groupdata = [
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "83713f0b-8de0-4e14-9f59-59ac9aee4bff",
      "name": "krishna4",
      "description": "hare krishna4",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-19T05:57:20.697Z",
      "updatedAt": "2023-01-19T05:57:20.697Z",
      "washers": []
    },
    {
      "id": "d05fa552-4e9a-45df-b62d-62aa191b69cd",
      "name": "krishna3",
      "description": "hare krishna3",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-18T11:47:30.064Z",
      "updatedAt": "2023-01-18T11:47:30.064Z",
      "washers": [
        {
          "id": 177,
          "name": "radha4",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-18T11:12:23.762Z",
          "updatedAt": "2023-01-19T08:57:12.542Z",
          "washer_groups": {
            "id": "11dfb55f-caf6-4f41-8283-3f5254e34890",
            "washerId": "177",
            "groupId": "d05fa552-4e9a-45df-b62d-62aa191b69cd",
            "createdAt": "2023-01-19T08:57:13.475Z",
            "updatedAt": "2023-01-19T08:57:13.475Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
    {
      "id": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
      "name": "krishna6",
      "description": "hare krishna6",
      "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
      "createdAt": "2023-01-23T05:04:55.762Z",
      "updatedAt": "2023-01-23T05:04:55.762Z",
      "washers": [
        {
          "id": 187,
          "name": "radha5",
          "faceId": null,
          "organizationId": "7caee275-b7cf-498f-91f0-613af35f093b",
          "rfid": null,
          "createdAt": "2023-01-23T05:05:26.024Z",
          "updatedAt": "2023-01-23T05:05:26.024Z",
          "washer_groups": {
            "id": "1aa5a1f4-259f-498b-8e1f-0863035eca99",
            "washerId": "187",
            "groupId": "6bf8f2fb-09b8-4862-8a3f-748f6a1ebbd9",
            "createdAt": "2023-01-23T05:05:26.704Z",
            "updatedAt": "2023-01-23T05:05:26.704Z"
          }
        }
      ]
    },
  ]

export default Groupdata;